export enum PromotionalType {
  BLOOMINGDALES_TOP_OF_LIST_TIER = "bloomingdales_top_of_list_tier",
  BLOOMINGDALES_LOYALIST_TIER = "bloomingdales_loyalist_tier",
  BANK_OF_AMERICA_PREFERRED_REWARDS_GOLD = "bank_of_america_preferred_rewards_gold",
  BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM = "bank_of_america_preferred_rewards_platinum",
  BANK_OF_AMERICA_PREFERRED_REWARDS_PLATINUM_HONORS = "bank_of_america_preferred_rewards_platinum_honors",
  BANK_OF_AMERICA_PREFERRED_REWARDS_DIAMOND_HONORS = "bank_of_america_preferred_rewards_diamond_honors",
  REQUIRE_BANK_OF_AMERICA_SMALL_BUSINESS_ACCOUNT = "require_bank_of_america_small_business_account",
  PRIME_MEMBERSHIP = "prime_membership",
  UPROMISE_COLLEGE_SAVINGS_PLAN = "upromise_college_savings_plan",
  US_BANK_SMARTLY_TIER_1 = "us_bank_smartly_tier_1",
  US_BANK_SMARTLY_TIER_2 = "us_bank_smartly_tier_2",
  US_BANK_SMARTLY_TIER_3 = "us_bank_smartly_tier_3",
  BILT_CONNECT_TO_LYFT = "bilt_connect_to_lyft",
  BILT_RENT_DAY = "bilt_rent_day",
  BILT_SPEND_RATIO_25 = "bilt_spend_ratio_25",
  BILT_SPEND_RATIO_50 = "bilt_spend_ratio_50",
  BILT_SPEND_RATIO_75 = "bilt_spend_ratio_75",
  BILT_SPEND_RATIO_100 = "bilt_spend_ratio_100",
  PENFED_HONORS_ADVANTAGE = "penfed_honors_advantage",
  CITI_NIGHTS = "citi_nights",
}
